var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper-user-header-component"},[_c('div',{staticClass:"header-title"},[_c('p',[_vm._v(_vm._s(_vm.$t("machine.title_Cash")))])]),_c('machine-new-modal',{on:{"action":_vm.search}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }